import { Directive, HostListener, inject, Input } from '@angular/core';
import { KlevuSearch } from './klevu-interfaces';
import { KlevuTrackService } from './klevu-track.service';

/**
 * ## Usage
 *
 * ```html
 * <a ... [klevuTrackClick]="{product: model, term: 'some term'}">...</a>
 * ```
 */
@Directive({
    selector: '[klevuTrackClick]',
    standalone: true
})
export class KlevuTrackClickDirective {
    @Input()
    klevuTrackClick?: KlevuSearch.ITrackSearchProductClickData;

    private klevuTrackService = inject(KlevuTrackService);

    /**
     * Click event listener
     */
    @HostListener('click')
    onClick() {
        const data = this.klevuTrackClick;
        if (data?.term) {
            this.klevuTrackService.trackSearchResultProductClick(data.term, data.product);
        }
    }
}
